import React from 'react';
import isEqual from 'is-equal';
import { guid } from 'src/services/util';
import { Row, Col, Image } from "react-bootstrap";
import blockIcon from 'src/legacy/images/blocked_pink.svg'
import styles from './styles.module.scss';
import cx from 'classnames';
import dateFormat from 'dateformat';
import TimeAgo from 'react-timeago';
import userRoleService from 'src/services/userRoles.service.js';
import Tooltip from "src/components/tooltip";
import _ from 'lodash';


import { localizedStrings } from 'src/localization/index.jsx';
import Text from 'src/components/text';

class ChatView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      message: '',
      displayMessages: '',
      asset: this.props.asset,
      showAssociations: false,
      selectedContact: null,
      showContactSlideView: false,
      chatUser: this.props.chatUser,
      blocked: false,
      showRecipientActions: false
    }

    this._handleChange = this._handleChange.bind(this);
    this._handleKeyDown = this._handleKeyDown.bind(this);
    this.sendMessage = this.sendMessage.bind(this);
    this.toggleContactSlide = this.toggleContactSlide.bind(this);
    this.toggleBlockView = this.toggleBlockView.bind(this);
    this.toggleLiveView = this.toggleLiveView.bind(this);

    this.localizedEngage = localizedStrings.pages.engage;
  }

  componentDidMount() {
    if (this.props.fetchMessages) {
      this.props.fetchMessages(_.get(this.props, 'smallTalk.client', null), [this.props.channelNames[0]], 100)
        .then(response => {
          this.scrollToBottom();
          this.props.updateUnreadForChatUser(this.props.channelNames[0]);
        });
    }
    
    if ( _.get(this.props.chatUser, 'blocked') || false ){
      this.setState({
        blocked: _.get(this.props.chatUser, 'blocked')
      });
    }

    if (this.props.chatUser.type == "contact") {
      this.props.fetchContact(this.props.chatUser.id);
    }
    {this.props.chatUser.isOnline &&
      this.props.fetchCurrentlyViewingAsset(this.props.chatUser.chatUserId);
    }
  }

  componentWillReceiveProps(nextProps) {

    this.setState({
      showAssociations: false,
      showRecipientActions: false
    })

    if (!isEqual(this.props.chatUser, nextProps.chatUser)){
      this.setState({
        chatUser: nextProps.chatUser
      })
    }

    if (!isEqual(this.props.contact, nextProps.contact)) {
      this.setState({
        selectedContact: nextProps.contact
      })
    }

    var currentId = this.props.id;
    var nextId = nextProps.id;

    var changed = true;
    if (currentId && nextId) {
      changed = currentId != nextId;
    }

    if (!isEqual(this.props.channelNames, nextProps.channelNames)) {
      {this.props.fetchMessages && 
      this.props.fetchMessages(_.get(this.props, 'smallTalk.client', null), [nextProps.channelNames[0]], 100).then(response => {
        this.scrollToBottom();
        this.props.updateUnreadForChatUser(nextProps.channelNames[0]);
      });}
      this.setState({
        asset: null
      })
    }

    if (changed && nextId) {
      {this.props.fetchMessages && 
      this.props.fetchMessages(_.get(this.props, 'smallTalk.client', null), [nextProps.channelNames[0]], 100).then(response => {
        this.scrollToBottom();
      });}

      if (nextProps.chatUser.type == "contact") {
        this.props.fetchContact(nextProps.chatUser.id);
      }
    }

    const oldMessages = this.props.messages;
    const newMessages = nextProps.messages;

    if (_.differenceWith(newMessages, oldMessages, _.isEqual).length > 0) {
      setTimeout(() => {
        this.scrollToBottom();
      }, 100);
    }

    if (!_.isEqual(this.props.assetId, nextProps.assetId)) {
      this.props.fetchAsset(nextProps.assetId);
    }

    if (!_.isEqual(this.props.asset, nextProps.asset)) {
      this.setState({
        asset: nextProps.asset
      })
    }
  }


  toggleLiveView() {
    this.props.toggleLiveView();
  }

  sendMessage(e) {
    e.preventDefault();

    // this.props.trackAdoptionMetricsForMessageSentEvent();
    const message = this.state.message.trim();
    if (message === '') {
      return;
    }

    let uuid;

    if (this.state.chatUser.type == "contact") {
      uuid = `a_${this.props.account.id}.c_${this.state.chatUser.id}`;
    } else {
      uuid = `a_${this.props.account.id}.v_${this.state.chatUser.id}`;
    }

    if (!this.state.chatUser.isAssociated) {
      this.props.associateChatUser(this.state.chatUser.chatUserId, uuid);
    }

    const request = {
      channel: this.props.channelNames[0],
      message: {
        id: guid(),
        type: "MESSAGE",
        text: message,
        timestamp: new Date().getTime(),
        fingerPrint: "" ,
        sharedUrl: '',
        sender: {
          chatUser: this.state.chatUser.chatUserId,
          id: this.props.user.id,
          name: `${_.get(this.props.user, 'firstName') || ''} ${_.get(this.props.user, 'lastName') || ''}`,
          type: 'user',
        }
      },
      uuid: this.props.uuid
    }

    if (!this.state.chatUser.isOnline && this.state.chatUser.type == "contact"){
      this.props.sendMessageAsEmail(this.state.chatUser.chatUserId, message);
    }

    this.props.sendMessage(_.get(this.props, 'smallTalk.client', null), request);
    this.setState({
      message: ''
    })
  };

  _handleChange(e) {
    var message = e.target.value;

    this.setState({
      message: message
    })
  }

  _handleKeyDown(e) {
    if (e.keyCode == 13 && e.shiftKey == false) {
      this.sendMessage(e);
    }
  }

  scrollToBottom() {
    if (!this.scrollContainer) {
      return;
    }

    this.scrollContainer.scrollIntoView();
  }

  renderInitials(chatUser) {
    let initial;

    if (chatUser.type == "visitor") {
      return <span className="paperflite-user-settings" />
    }

    if (chatUser.firstName) {
      initial = chatUser.firstName.charAt(0).toUpperCase();
    }

    if (chatUser.lastName) {
      initial = initial + chatUser.lastName ? chatUser.lastName.charAt(0).toUpperCase() : '';
    }

    return initial;
  }

  renderOnlineStatus(chatUser) {
    return <TimeAgo date={chatUser.lastOnline} live={false} />
  }

  toggleContactSlide() {
    this.props.showContactSlideView(this.state.selectedContact);
  }

  toggleBlockView() {
    this.props.showBlockConfirmationView(!this.state.chatUser.blocked);
  }

  renderRecipientActions(){
      return(
        <div onClick={() => this.toggleBlockView()} className={cx(styles.recipientActions, styles.associatedPopup, styles.recipientActionsPopup)}>
          <span className={styles.blockIconRecipient}>
          <i className={`fa fa-ban ${styles.blockIcon}`} aria-hidden="true"></i>
            <p className={styles.blockIconName}>{this.localizedEngage.individual_chat.actions.block_recipient}</p>
          </span>
        </div>
      )
  }

  renderUserAssociations() {
    var children = Array();

    this.props.userAssociations.forEach(userAssociation => {
      children.push(
        <Row className={styles.userAssociationRow}>
          <Col sm={2}>
            {!userAssociation.icon &&
              <div className={styles.userAssociationIcon}> {this.renderInitials(userAssociation)} </div>
            }
            {userAssociation.icon &&
              <Image className={styles.userAssociationIcon} src={userAssociation.icon.thumbnail} circle />
            }
          </Col>
          <Col sm={10}>
            {userAssociation.firstName} {userAssociation.lastName}
          </Col>
        </Row>
      )
    });

    return children;
  }

  render() {
    if (!this.state.chatUser) {
      return null;
    }
    const localizedChat = this.localizedEngage.individual_chat.chat_details;

    return (
      <Row className={styles.container}>
        <Col sm={12} className={styles.header}>
          <Col sm={1} onClick={() => { this.toggleContactSlide() }}>
            <div className={styles.iconContainer}>
              {this.state.chatUser.isOnline &&
                <div className={styles.online}></div>
              }
              {!this.state.chatUser.icon &&
                <div className={styles.chatUserAvatar}> {this.renderInitials(this.state.chatUser)} </div>}
              {this.state.chatUser.icon &&
                <Image className={styles.chatUserIcon} src={this.state.chatUser.icon.thumbnail} circle />}
            </div>
          </Col>
          <Col sm={10} className={styles.chatUserDetails}>
              <span className={styles.chatUserName}>
                <span onClick={() => this.toggleContactSlide()}>
                  <Text className={styles.chatUserTruncatedName} tooltip={{placement:"bottom"}} lines={1} text={`${this.state.chatUser.firstName || ''} ${this.state.chatUser.lastName || ''}`}  />
                </span>
              {this.state.showRecipientActions && this.renderRecipientActions()}
              </span>
              {!this.state.chatUser.blocked && userRoleService.canBlockRecipient() &&
              <span
                className={cx("fa fa-angle-down", styles.downArrow)}
                onClick={() => {
                  this.setState({
                    showRecipientActions: !this.state.showRecipientActions
                  })
                }}></span> 
              }
              {_.get(this.state.chatUser, 'country.country_name') && 
                <p className={styles.presenceStatus}>
                  <i className="fa fa-map-marker" aria-hidden="true"></i> {`${_.get(this.props.chatUser, 'country.city')}, ${_.get(this.props.chatUser, 'country.country_name')}`}
                </p>
              }
          </Col>
          <Col sm={1} className={styles.detailsIcon}>
            <p className={styles.showDetailsIcon} onClick={() => {
              this.setState({
                showAssociations: !this.state.showAssociations
              })
            }}>...</p>
          </Col>
        </Col>
        {this.props.userAssociations && this.props.userAssociations.length > 0 && this.state.showAssociations &&
          <div className={styles.associatedPopup}>
            <p>
            {this.localizedEngage.individual_chat.actions.participants}
            </p>
            <button className={styles.button}>
              <i onClick={() => {
                this.setState({
                  showAssociations: false
                })
              }} className="fa fa-angle-left"></i>
            </button>
            {this.renderUserAssociations()}
          </div>
        }
        <Col sm={12} className={styles.chatUserHeader}>
          <span className={styles.divider} />
        </Col>
        <Col sm={12} className={styles.messages}>
          {this.renderMessages()}
          <div ref={(element) => this.scrollContainer = element}></div>
        </Col>
        {!this.state.chatUser.isOnline && !this.state.chatUser.blocked && 
          <Col sm={12}>
            <div className={cx(styles.sendToMail, {[styles.contactMessage]: this.state.chatUser.type == "contact", [styles.viewOnly]: userRoleService.isEngageViewOnly()})}>
              <div className={cx(styles.sendToMailIcon, styles.iconContainer)}>
                {!this.state.chatUser.icon &&
                  <div className={styles.chatUserAvatar}> {this.renderInitials(this.state.chatUser)} </div>}
                {this.state.chatUser.icon &&
                  <Image className={styles.chatUserIcon} src={this.state.chatUser.icon.thumbnail} circle />}
              </div>
              <div className={styles.offlineStatus}>
                <p className={styles.offline}>{this.localizedEngage.individual_chat.chat_details.last_online} {this.renderOnlineStatus(this.state.chatUser)}</p>
                <p className={styles.offlineName}>{`${this.state.chatUser.firstName || ''} ${this.state.chatUser.lastName || ''}`} {this.localizedEngage.individual_chat.chat_details.subject}</p>
                {this.state.chatUser.type == "contact" && !userRoleService.isEngageViewOnly() &&
                  <p className={styles.offlineSubText}>
                    {this.localizedEngage.individual_chat.chat_details.description}
                  </p>
                }
              </div>
            </div>
          </Col>
        }
        {this.state.chatUser.blocked && 
          <Col sm={12}>
            <div className={cx(styles.blockedView)} >
              <div className={styles.offlineStatus}>
                <p className={styles.blockedHeading}>{this.localizedEngage.individual_chat.chat_details.blocked.title}</p>
                {userRoleService.canBlockRecipient() &&
                <span>
                  <p className={styles.blockedSubHeading}>
                  {this.localizedEngage.individual_chat.chat_details.blocked.sub_text}
                  </p>
                  <p onClick={() => this.toggleBlockView()} className={styles.unblockButton}>{this.localizedEngage.individual_chat.chat_details.blocked.unblock}</p>
                </span>
                }
              </div>
            </div>
          </Col>
        }
        {!userRoleService.isEngageViewOnly() && 
          <span>
            {this.state.chatUser.isOnline && this.state.asset && !this.state.chatUser.blocked &&
              <p className={styles.currentlyViewing}>
                {this.props.liveViewUpdated ? localizedChat.currently_viewing: localizedChat.last_viewed}
                <span onClick={this.toggleLiveView}
                  className={styles.assetName}>
                  {this.state.asset.name}
                </span>
              </p>
            }
            {!this.state.chatUser.blocked &&
              <Col sm={12}>
                <form className={styles.composer} onSubmit={this.sendMessage}>
                  <textarea
                    disabled={this.state.chatUser.type == "visitor" && !this.state.chatUser.isOnline}
                    className={styles.reply}
                    placeholder= {`${this.localizedEngage.individual_chat.chat_details.chat.placeholder}...`}
                    onChange={this._handleChange}
                    value={this.state.message}
                    onKeyDown={this._handleKeyDown}
                  />
                  <button type='submit' className={cx(styles.send, { [styles.disabled]: (!this.state.chatUser.isOnline && this.state.chatUser.type == "visitor") })}>
                    <i className={!this.state.chatUser.isOnline && this.state.chatUser.type == "contact" ? "paperflite-mail" : "fa fa-paper-plane"} aria-hidden="true"></i>
                  </button>
                </form>
              </Col>}
          </span>
        }
      </Row>
    )
  }

  renderMessages() {

    const rows = this.props.messages.map((chat, index) => {
      var sender = chat.sender.name.charAt(0);
      var id = chat.id || index;

      return (
        <div key={id} className={cx(styles.message, {
          [styles.right]: chat.sender.type === 'user'
        })}>
          <div className={styles.inner}>
          <div className={styles.avatar}>
            <Tooltip content={chat.sender.name} className={styles.senderNameToolTip} placement='bottom'>
              <span data-tip data-for={id}>{sender}</span>
            </Tooltip>
          </div>

            <div className={cx(styles.bubble)}>
              {chat.text}
            </div>
          </div>
          <div className={styles.createdDate}>
            {dateFormat(chat.timestamp / 10000, 'mmm d, yy hh:MM TT')}
          </div>
        </div>
      );
    });

    return rows;
  }

  renderAvatar(entity) {
    return `${_.get(entity, 'firstName[0]') || ''}${_.get(entity, 'lastName[0]') || ''} `;
  }

}

export default ChatView;